<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="btn-voltar"
            color="primary"
            x-small
            text
            @click="() => $router.back()"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lançando Frequências
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="aula">
        <v-card id="card-aula" color="green lighten-1" class="mb-5" outlined>
          <v-card-title id="card-title-professor">
            Professor: {{ aula.professor.nome }}
          </v-card-title>
          <v-card-subtitle id="card-subtitle-turma" class="font-weight-medium">
            <div id="turma-descricao">Turma: {{ aula.turma.descricao }}</div>
            <div v-if="aula.disciplina" id="disciplina-descricao">
              Disciplina: {{ aula.disciplina?.descricao }}
            </div>
            <div v-else>
              <div
                v-for="(item, index) in aula.disciplinas"
                :key="index"
                :id="`disciplina-chip-${index}`"
              >
                <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
              </div>
            </div>
            <div id="data-aula">Data: {{ aula.data_formatada }}</div>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="aula && presencas.length">
      <v-col cols="12">
        <v-simple-table id="tabela-presencas">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Aluno</th>
                <th class="text-left">Presença</th>
                <th class="text-left">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="presenca of presencas"
                :key="presenca.matricula_id"
                :id="`linha-presenca-${presenca.matricula_id}`"
                :class="getRowClass(presenca)"
              >
                <td class="font-weight-medium" :id="`coluna-aluno-${presenca.matricula_id}`">
                  <div>
                    {{
                      presenca.matricula.aluno
                        ? presenca.matricula.aluno.nomecompleto
                        : `[ALUNO POSSIVELMENTE DELETADO] MATRICULA: ${presenca.matricula.id}`
                    }}
                    <v-chip
                      label
                      color="error"
                      small
                      v-if="
                        $constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      :id="`chip-situacao-${presenca.matricula_id}`"
                      >{{ presenca.matricula.situacao }}</v-chip
                    >
                  </div>
                  <div>
                    <small>
                      {{
                        presenca.matricula.aluno ? presenca.matricula.aluno.codigo_inep : "- - -"
                      }}
                      /
                      {{ presenca.matricula.aluno ? presenca.matricula.aluno.codigo : "- - -" }}
                    </small>
                  </div>
                </td>
                <td :id="`coluna-presenca-${presenca.matricula_id}`">
                  <v-btn-toggle :value="presenca.presente ? 0 : 1" v-if="presenca.matricula.aluno">
                    <v-btn
                      v-if="
                        !$constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      @click="
                        aula.presencas_confirmadas
                          ? mostrarAvisoConfirmado()
                          : atualizarFrequencia(presenca, true)
                      "
                      :color="presenca.presente ? 'green' : 'grey lighten-2'"
                      :style="aula.presencas_confirmadas ? 'opacity: 0.5;' : ''"
                      small
                      :id="`btn-presente-${presenca.matricula_id}`"
                    >
                      <v-icon :class="presenca.presente ? 'white--text' : ''" x-small>
                        fa fa-thumbs-up
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="
                        !$constants.situacoesMatriculaCondition[
                          removerEspaco(
                            presenca.matricula.situacao ? presenca.matricula.situacao : ''
                          )
                        ]
                      "
                      @click="
                        aula.presencas_confirmadas
                          ? mostrarAvisoConfirmado()
                          : atualizarFrequencia(presenca, false)
                      "
                      :color="!presenca.presente ? 'red' : 'grey lighten-2'"
                      :style="aula.presencas_confirmadas ? 'opacity: 0.5;' : ''"
                      small
                      :id="`btn-ausente-${presenca.matricula_id}`"
                    >
                      <v-icon :class="!presenca.presente ? 'white--text' : ''" x-small>
                        fa fa-thumbs-down</v-icon
                      >
                    </v-btn>
                  </v-btn-toggle>
                </td>
                <td :id="`coluna-acoes-${presenca.matricula_id}`">
                  <v-btn
                    v-if="!presenca.presente"
                    color="success"
                    @click="modalFalta(presenca.matricula, presenca.justificativa_id)"
                    small
                    type="button"
                    :id="`btn-observacao-${presenca.matricula_id}`"
                  >
                    Observação
                  </v-btn>
                  <v-tooltip v-if="!presenca.presente && presenca.document" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        @click="documentoJustificativaFalta(presenca.matricula.id)"
                        class="ml-2"
                        color="red lighten-5"
                        v-bind="attrs"
                        v-on="on"
                        :id="`btn-baixar-documento-${presenca.matricula_id}`"
                      >
                        <v-icon color="red lighten-1" small> fa fa-file-pdf</v-icon>
                      </v-btn>
                    </template>
                    <span>Baixar documento</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col>
        <v-card class="elevation-2 pa-4 rounded-lg">
          <div class="d-flex justify-space-between align-center flex-wrap">
            <div class="d-flex flex-column flex-sm-row align-start align-sm-center flex-wrap">
              <div class="instruction-text mb-2 mb-sm-0 mr-sm-4">
                <v-icon small class="mr-2 text--secondary">mdi-information-outline</v-icon>
                <span class="text-body-2 font-weight-medium">
                  Verifique as presenças antes de confirmar
                </span>
              </div>

              <div class="legend-container d-flex align-center flex-wrap">
                <span class="text-caption text--secondary mr-3 font-weight-medium">Legenda:</span>

                <div class="legend-item d-flex align-center mr-4">
                  <v-chip x-small color="green" text-color="white" class="mr-1 pa-3">
                    <v-icon x-small left>fa fa-thumbs-up</v-icon>
                    Presença
                  </v-chip>
                </div>

                <div class="legend-item d-flex align-center">
                  <v-chip x-small color="red" text-color="white" class="mr-1 pa-3">
                    <v-icon x-small left>fa fa-thumbs-down</v-icon>
                    Falta
                  </v-chip>
                </div>
              </div>
            </div>

            <div class="action-container mt-3 mt-sm-0">
              <v-btn
                :color="aula.presencas_confirmadas ? 'green' : 'primary'"
                :outlined="!aula.presencas_confirmadas"
                :depressed="aula.presencas_confirmadas"
                elevation="0"
                class="font-weight-medium"
                @click="abrirModalConfirmacao"
                :style="aula.presencas_confirmadas ? 'pointer-events:none;' : ''"
                dark
              >
                <v-icon left class="mr-1">
                  {{ aula.presencas_confirmadas ? "mdi-check-circle" : "mdi-check-circle-outline" }}
                </v-icon>

                <span>
                  {{ aula.presencas_confirmadas ? "Confirmado" : "Confirmar Frequência" }}
                </span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-alert v-else color="primary" outlined prominent text type="warning">
      Sem matriculas cadastradas para essa turma.
    </v-alert>
    <v-snackbar
      dense
      :value="exibirSnackbar"
      :timeout="-1"
      class="mb-12"
      :color="snackbarColor"
      right
      bottom
      id="snackbar-status"
    >
      <div v-if="promisesCount > 0" class="d-flex align-center">
        <v-progress-circular indeterminate size="25" color="white"></v-progress-circular>
        <span class="ml-2 font-weight-medium">Salvando dados de frequência no servidor</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon id="btn-fechar-snackbar"
          ><v-icon small>fa fa-close</v-icon></v-btn
        >
      </div>
      <div v-else-if="errorMessages.length == 0" class="d-flex align-center">
        <v-icon size="20" color="white">fa fa-check</v-icon>
        <span class="ml-2 font-weight-medium">Dados de frequência salvos no servidor!</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon id="btn-fechar-snackbar-sucesso"
          ><v-icon small>fa fa-close</v-icon></v-btn
        >
      </div>
      <div v-else class="d-flex align-center">
        <v-icon size="20" color="white">fa fa-exclamation-circle</v-icon>
        <span class="ml-2 font-weight-medium">Erro ao salvar dados de frequência!</span>
        <v-btn @click="fecharSnackbar" class="ml-2" icon id="btn-fechar-snackbar-erro"
          ><v-icon small>fa fa-close</v-icon></v-btn
        >
      </div>
    </v-snackbar>
    <ModalJustificarFalta
      v-model="modalJustificativaAberto"
      :aula="aula"
      :matricula="matriculaSelecionada"
      :justificativa-id="justificativaIdSelecionada"
      @sucesso="onJustificativaSalva"
    />

    <!-- Mantenha seu ModalConfirmacao existente -->
    <ModalConfirmacao
      v-model="showConfirmacaoModal"
      titulo="Confirmar Frequência"
      acao="confirmar a frequência desta aula"
      icon="mdi-account-check"
      icon-color="primary"
      texto-confirmar="Sim, Confirmar"
      cor-botao-confirmar="success"
      icone-botao-confirmar="mdi-check-circle"
      aviso-tipo="info"
      ref="modalConfirmacao"
      @confirmado="confirmarFrequencia"
    />
  </main-template>
</template>

<script>
import ModalConfirmacao from "../../components/EModalConfirmacao.vue";
import ModalJustificarFalta from "../../components/EModalJustificarFalta.vue";

export default {
  props: {
    aula_id: {
      type: [String, Number],
      required: true,
    },
  },

  components: {
    ModalConfirmacao,
    ModalJustificarFalta,
  },

  mounted() {
    this.loadBasicData();
    this.getDisciplinas();
  },
  data() {
    return {
      disciplinas: [],
      submittingForm: false,
      aula: {},
      presencas: [],
      exibirSnackbar: false,
      promisesCount: 0,
      errorMessages: [],
      justificativas: [],
      form: {
        observacao: "",
        file: null,
        matriculaSelect: {},
        justificativa_id: 0,
      },
      matriculaSelect: {},
      modalJustificativaAberto: false,
      matriculaSelecionada: {},
      justificativaIdSelecionada: null,
      showConfirmacaoModal: false,
    };
  },
  computed: {
    snackbarColor() {
      if (this.errorMessages.length > 0) return "error";
      return this.promisesCount > 0 ? "info" : "success";
    },
  },
  methods: {
    async getDisciplinas() {
      this.disciplinas = await this.$services.disciplinasService.syncAll();
      // const response = await this.$services.aulasService.disciplinas();
      // this.disciplinas = response.disciplinas;
    },
    getNomeDisciplina(id) {
      const discplina = this.disciplinas.filter((obj) => obj.id === id);
      return discplina[0].descricao;
      // const dis = this.gestaoDeAula.disciplinas.filter((obj) => obj.id === id);
      // return dis[0].descricao;
    },
    async loadBasicData() {
      this.$loaderService.open("Carregando dados...");

      try {
        const response = await this.$services.aulasService.justificativas();
        this.justificativas = response.justificativas;

        const aula = await this.$services.aulasService.getAulaComRelacoes(this.aula_id);
        this.aula = aula;

        this.presencas = aula.turma.matriculas.map((matricula) => {
          const faltou =
            this.aula.faltas.filter(
              (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
            ).length > 0;

          const falta = this.aula.faltas.filter(
            (falta) => parseInt(falta.matricula_id, 10) === parseInt(matricula.id, 10)
          );

          return {
            matricula,
            matricula_id: matricula.id,
            presente: !faltou,
            document: falta[0] ? falta[0].document : null,
            justificativa_id: falta[0] ? falta[0].justificativa_id : null,
          };
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async atualizarFrequencia(frequencia, novoEstado) {
      frequencia.presente = novoEstado;
      this.exibirSnackbar = true;
      this.promisesCount += 1;
      try {
        await this.$services.aulasService.registrarPresenca(this.aula, frequencia);
      } catch (error) {
        this.errorMessages.push(error.message);
        this.$handleError(error);
      }
      this.promisesCount -= 1;
    },
    modalFalta(matricula, justificativa_id) {
      this.matriculaSelecionada = matricula;
      this.justificativaIdSelecionada = justificativa_id;
      this.modalJustificativaAberto = true;
    },
    async onJustificativaSalva(dados) {
      if (dados && dados.matricula_id) {
        const presencaIndex = this.presencas.findIndex(
          (p) => p.matricula_id === dados.matricula_id
        );

        if (presencaIndex !== -1) {
          this.$set(this.presencas, presencaIndex, {
            ...this.presencas[presencaIndex],
            justificativa_id: dados.justificativa_id,
            document: dados.hasDocument,
          });
        }
      } else {
        await this.loadBasicData();
      }
    },
    fecharSnackbar() {
      this.exibirSnackbar = false;
      this.errorMessages = [];
    },
    removerEspaco(string) {
      return string.replace(" ", "_").replace(" ", "_").replace(" ", "_");
    },
    async documentoJustificativaFalta(matricula_id) {
      this.$loaderService.open("Baixando...");
      try {
        await this.$services.relatoriosService.documentoJustificativaFalta(
          parseInt(this.aula.id, 10),
          parseInt(matricula_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async confirmarFrequencia() {
      this.$refs.modalConfirmacao.setLoading(true);

      try {
        await this.$services.aulasService.confirmarFrequencia(parseInt(this.aula.id, 10));
        this.$toast.success("Frequência confirmada com sucesso");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
        this.showConfirmacaoModal = true;
      } finally {
        this.$refs.modalConfirmacao.setLoading(false);
      }
    },

    abrirModalConfirmacao() {
      this.showConfirmacaoModal = true;
    },
    mostrarAvisoConfirmado() {
      this.$toast.warn("Não é possível alterar a frequência após confirmar as presenças.");
    },
    getRowClass(presenca) {
      const situacaoAdversa =
        this.$constants.situacoesMatriculaCondition[
          this.removerEspaco(presenca.matricula?.situacao ? presenca.matricula?.situacao : "")
        ];

      const especial = presenca.matricula?.aluno.especial;

      if (situacaoAdversa && especial) {
        return "red lighten-4";
      }

      if (situacaoAdversa) {
        return "red lighten-4";
      }

      if (especial) {
        return "blue_light";
      }

      return "";
    },
  },
};
</script>
